import { DateTime } from 'luxon';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline/periodScale';
import { getQuarterFromMonth } from './quarter';

export const longDateRangeFormat = ({
  start,
  end,
  format = DateTime.DATE_MED
}) => {
  if (start && end && start === end) return start.toLocaleString(format);

  return `${start ? start.toLocaleString(format) : ''} — ${
    end ? end.toLocaleString(format) : ''
  }`;
};

export const shortDateRangeFormat = ({
  start,
  end,
  format = DateTime.DATE_MED
}) => {
  if (start && end && start === end) {
    return start.toLocaleString(format);
  }

  if (start && end && start.year === end.year) {
    if (start.month === end.month) {
      return `${start.toLocaleString({
        month: 'short',
        day: 'numeric'
      })}—${end.toFormat('d yyyy')}`;
    }

    return `${start.toLocaleString({
      month: 'short',
      day: 'numeric'
    })} — ${end.toLocaleString(DateTime.DATE_MED)}`;
  }

  return longDateRangeFormat({ start, end, format });
};

export const formatDateRangeLabel = (scale, start, end, formatMessage) => {
  if (scale === PERIOD_SCALE_ENUM.DAYS) {
    return start.toLocaleString({ month: 'short', day: 'numeric' });
  }

  if (scale === PERIOD_SCALE_ENUM.WEEKS) {
    return shortDateRangeFormat({ start, end });
  }

  if (scale === PERIOD_SCALE_ENUM.MONTHS) {
    return start.toLocaleString({ month: 'long', year: 'numeric' });
  }

  if (scale === PERIOD_SCALE_ENUM.QUARTERS) {
    const quarter = getQuarterFromMonth(start.month);
    const year = end.toLocaleString({ year: 'numeric' });
    const quarterAbbr = formatMessage({ id: 'chart.quarterAbbreviated' });

    return `${quarterAbbr}${quarter} ${year}`;
  }

  return start.toLocaleString({ year: 'numeric' });
};
